/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_Not_Synced_HintInputs */

const cs_auth_google_not_synced_hint = /** @type {(inputs: Auth_Google_Not_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Google pro tento e-mail ještě není nastavené. Přihlaste se níže heslem, pak v Nastavení profilu → Google účet → Propojit. Stačí jednou.`)
};

const en_auth_google_not_synced_hint = /** @type {(inputs: Auth_Google_Not_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in is not set up for this email yet. Sign in with your password below, then open Profile settings → Google account → Connect.`)
};

/**
* | output |
* | --- |
* | "Google sign-in is not set up for this email yet. Sign in with your password below, then open Profile settings → Google account → Connect." |
*
* @param {Auth_Google_Not_Synced_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_not_synced_hint = /** @type {((inputs?: Auth_Google_Not_Synced_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_Not_Synced_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_not_synced_hint(inputs)
	return cs_auth_google_not_synced_hint(inputs)
});